import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  BehaviorSubject,
  Observable,
  Subject} from "rxjs";
import { AuthAmplifyService } from "src/app/shared/service/auth-amplify.service";
import { environment } from "src/environments/environment";
import { CuratedTourRequest } from "../interfaces/business-tour-create.interface";
import { TranslationService } from "src/app/shared/service/translation.service";
import { MediaCarouselService } from "./media/media-carousel.service";
declare const H: any;

@Injectable({
  providedIn: "root",
})
export class LocationsHttpService {
  baseUrl: string;
  access_token: string | null;
  qrCode_api_header: any;
  private platform: any;

  circuitData: any = {};
  trackData: any = {};
  mediaData: any = [];
  public circuitContent = new BehaviorSubject<any>(this.circuitData);
  public shareCircuitData = this.circuitContent.asObservable();
  public trackContent = new BehaviorSubject<any>(this.trackData);
  public shareTrackData = this.trackContent.asObservable();
  public circuitFormContent = new Subject<any>();
  public formContent = new Subject<any>();
  public shareCircuitformData = this.circuitFormContent.asObservable();
  public shareformData = this.formContent.asObservable();
  public mediaContent = new BehaviorSubject<any[]>([]);
  public sharemediaData = this.mediaContent.asObservable();
  public deleteMediaContent = new BehaviorSubject<any[]>([]);
  public deletemediaData = this.deleteMediaContent.asObservable();
  public selectedType = new Subject<any>();
  public shareSelectedType = this.selectedType.asObservable();
  proxyEndpoint:string = environment.proxyUrl

  constructor(private readonly httpClient: HttpClient, 
    private readonly authAmplifyService: AuthAmplifyService,
    private readonly _translationService: TranslationService,
    private readonly _commonMediaService: MediaCarouselService) {
    this.baseUrl = environment.apiEndPoint;
    
    const tokenData = this.authAmplifyService.getCurrentUserToken();
    const mapKey = _translationService.allSecrets.hereMapApiKey
    this.access_token = tokenData?.access_token;
    if (typeof H !== 'undefined' && mapKey) {
      this.platform = new H.service.Platform({
        apikey: mapKey,
      });
    }
  }

  sendFormValue(value: any) {
    this.formContent.next(value);
  }
  sendCircuitFormValue(value: any) {
    this.circuitFormContent.next(value);
  }
  sendSelectedTypeValue(value: any) {
    this.selectedType.next(value);
  }
  sendMediaValue(value: any) {
    this.mediaContent.value.push(value);
  }

  clearMediaValue() {
    this.mediaContent.next([]);;
  }

  sendDeleteMediaValue(value:  any) {
    this.deleteMediaContent.value.push(value);
  }

  getLatestTrackDetails(data: any) {
    this.trackContent.next(data);
  }

  /**
   * @description This is a new API to get all the data for the map view - circuits, emotion tours and offroad tours
   * @param emotionTourLimit 
   * @param circuitLimit 
   * @param offroadLimit 
   * @param point 
   * @param radius 
   */
  public getAllMapViewData(emotionTourLimit: number, circuitLimit: number, offroadLimit: number, point: any, radius: number): Observable<any> {
    const locationFeatureFlags = this._translationService.featureFlags.locations;
    const offroadEnabled = locationFeatureFlags.enableoffroadfeature;
    const offroadParkEnabled = locationFeatureFlags.enableOffroadPark;
    const offroadParkLimit = offroadParkEnabled ? offroadLimit : 0;
    offroadLimit = offroadEnabled ? offroadLimit: 0;
    const visibilty = "PERMANENT,TEMPORARY";

    const url = `${this.proxyEndpoint}/callLocApi/v4/search/mapview?limitForEmotionTours=${emotionTourLimit}&limitForCircuits=${circuitLimit}&limitForOffRoadTours=${offroadLimit}&point=${point}&radius=${radius}&offRoadTours=${offroadEnabled}&level=0&limitForOffRoadParks=${offroadParkLimit}&visibility=${visibilty}`;
    return this.httpClient.get<any>(url, {observe: 'response', withCredentials: true});
  }

  getCircuitsList(
    pageSize: any,
    pageNo: any,
    circuitsWithLayout: boolean
  ): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v1/circuits?size=${pageSize}&pageNumber=${pageNo}&circuitsWithLayout=${circuitsWithLayout}`;
    return this.httpClient.get<any>(url,  {observe: 'response', withCredentials: true});
  }

  deleteCircuit(guid: any) {
    const url = `${this.proxyEndpoint}/callLocApi/v1/circuit?guid=${guid}`;
    return this.httpClient.delete<any>(url, {observe: 'response', withCredentials: true});
  }

  deleteTrack(guid: any) {
    const url = `${this.proxyEndpoint}/callLocApi/v2/track?guid=${guid}`;
    return this.httpClient.delete<any>(url, {observe: 'response', withCredentials: true});
  }

  public getCircuit(guid: any) {
    const url = `${this.proxyEndpoint}/callLocApi/v1/circuit?guid=${guid}`;
    return this.httpClient.get<any>(url, {observe: 'response', withCredentials: true});
  }

  getLatestCircuitDetails(data: any) {
    this.circuitContent.next(data);
  }

  searchCircuits(
    pageSize: any,
    pageNo: any,
    nameMatches: any,
    circuitsWithLayout: boolean
  ) {
    const url = encodeURI(
      `${this.baseUrl}/v1/circuits?size=${pageSize}&pageNumber=${pageNo}&nameMatches=${nameMatches}&circuitsWithLayout=${circuitsWithLayout}`
    );
    return this.httpClient.get<any>(url);
  }

  updateCircuit(data: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v1/circuit/update`;
    return this.httpClient.put(url, data, {observe: 'response', withCredentials: true});
  }

 /**
   * @description This API is added to update a circuit. It takes name, guid, description
   * It also takes media and copy right info as input and updates a circuit
   * @param data 
   * @param media 
   * @returns 
   */
  public updateCircuitWithMedia(data: any, geofenceTypeSelected: string, media?: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v2/circuit/update?circuitType=${geofenceTypeSelected}`;
    let formData = new FormData();
    formData.append(
      "circuitJson",
      new Blob([JSON.stringify(data)], {
        type: "application/json",
      })
    );
    for (let i = 0; i < media?.length; i++) {
      formData.append("media", media[i]);
    }
    this.mediaContent.next([]);
    this.deleteMediaContent.next([]);

    return this.httpClient.put(url, formData, {observe: 'response', withCredentials: true});
  }

  UpdateTrackDetails(userId: string, data?: any, media?: File[], isCopyrightUpdate: boolean = false, isOffroadFlow: boolean = true): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v3/track?userId=${userId}`;
    const formData = new FormData();

    if (data) {
      const requestData = isCopyrightUpdate 
      ? this._commonMediaService.updateTrackUpdateRequestWithCopyright(isOffroadFlow ? data: data.guid)
      : data;
      if (!isOffroadFlow) {
        Object.keys(data).forEach(key => {
          if (!(key in requestData)) {
            requestData[key] = data[key];
          }
        });
      }
      formData.append("params", new Blob([JSON.stringify(requestData)], { type: "application/json" }));
    }

    if (media?.length) {
      media.forEach(file => formData.append("media", file));
    }

    this.mediaContent.next([]);

    return this.httpClient.put(url, formData, {observe: 'response', withCredentials: true});
  }

  /**
   * @description As part of BETRACKPRO-19993, this API is depricated and moved to v3
   * @param data 
   * @param media 
   * @returns 
   */
  saveAnnotationWithMedia(data?: any, media?: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v2/annotation/create`;
    let formData = new FormData();
    formData.append(
      "annotation",
      new Blob([JSON.stringify(data)], {
        type: "application/json",
      })
    );
    for (let i = 0; i < media?.length; i++) {
      formData.append("media", media[i]);
    }
    
    this.mediaContent.next([]);
    this.deleteMediaContent.next([]);

    return this.httpClient.post(url, formData,  {observe: 'response', withCredentials: true});
  }

  /**
   * @description This API is called to update annotations
   * @param data 
   * @param media 
   * @returns Observable
   */
  public editAnnotationWithMedia(data?: { annotationId: string, description: string, name: string }, media?: any[]): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v1/annotation/update`;
    const formData = new FormData();

    if (data) {
      const requestData = this._commonMediaService.updateAnnotationRequestWithMedia(data, true)
      formData.append(
        "annotationJson",
        new Blob([JSON.stringify(requestData)], {
          type: "application/json",
        })
      );
    }

    this.mediaContent.next([]);
    this.deleteMediaContent.next([]);

    return this.httpClient.put(url, formData, { observe: 'response', withCredentials: true });
  }

  public createAnnotationWithMedia(data: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v3/annotation/create`;
    let formData = new FormData();
    if (data) {
      formData.append(
        "annotation",
        new Blob([JSON.stringify(data)], {
          type: "application/json",
        })
      );
    }

    const requestData = this._commonMediaService.updateAnnotationRequestWithMedia(data, false).metadata;
    formData.append('metadata', new Blob([JSON.stringify(requestData)], {
      type: "application/json",
    }))
    
    this.mediaContent.next([]);
    this.deleteMediaContent.next([]);

    return this.httpClient.post(url, formData,  {observe: 'response', withCredentials: true});
  }



  getCategories(data: any): Observable<any> {
    const url = `${this.proxyEndpoint}/checkgeojson/v1/tour/categories`;
    return this.httpClient.post(url, data, {observe: 'response', withCredentials: true});
  }

  createEmotionTourPreview(data: any): Observable<any> {
    const url = `${this.proxyEndpoint}/checkgeojson/v1/tour/journey`;
    return this.httpClient.post(url, data,{observe: 'response', withCredentials: true});
  }

  /**
   * @description this is a curated tour API called when we click on Category and when Curated toggle is tourned on
   * This is an alternative /journey API that does not enhance the tour
   * @param data 
   * @returns 
   */
  public createCuratedBusinessTour(curatedTourRequest: CuratedTourRequest): Observable<any> {
    const url = `${this.proxyEndpoint}/checkgeojson/v1/tour/curated`;
    return this.httpClient.post(url, curatedTourRequest,{observe: 'response', withCredentials: true});
  }
/**
   * @description This API is added to create a circuit. It takes name, guid, description
   * and media files as input and creates a circuit. Also as aprt of BETRACKPRO-18495
   * we are adding a copyright info with media files
   * @param data 
   * @param media 
   * @returns Observable
   */
  public createCircuit(data: any,  geofenceType: string, media?: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v2/circuit/create?circuitType=${geofenceType}`;
    let formData = new FormData();
    formData.append(
      "circuitJson",
      new Blob([JSON.stringify(data)], {
        type: "application/json",
      })
    );
    for (let i = 0; i < media?.length; i++) {
      formData.append("media", media[i]);
    }
    this.mediaContent.next([]);
    this.deleteMediaContent.next([]);

   
    return this.httpClient.put(url, formData, {observe: 'response', withCredentials: true});
  }

  /**
   * @description This API is called to upload tracks/trails
   * @param data 
   * @param autoAnnotate 
   * @returns Observable
   */
  public uploadTrack(data: any, isEventsFlow: boolean = false, trackType?:string, autoAnnotate?: boolean): Observable<any> {
    const url = `${this.proxyEndpoint}/uploadGpxs/v1/track/upload`;
    const formData = new FormData();
    formData.append("file", data);
    formData.append("userId", "10");
    if(isEventsFlow) {
      formData.append("trackCategory", " ");
    } else {
      formData.append("trackCategory", trackType ?? "RACE_TRACKS");
    }   
    formData.append("autoAnnotate", autoAnnotate ? "true": "false")
    if (isEventsFlow) {
      formData.append("visibility", "PERMANENT");
    }
    return this.httpClient.post(url, formData, {observe: 'response', withCredentials: true});
  }

  getTrackDetails(guid: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v1/track?guid=${guid}`;
    return this.httpClient.get(url,{observe: 'response', withCredentials: true});
  }

  downloadTrackDetails(guid: any, trackVersion?: string) {
    let api_headers:any = {
        "Content-Type": "application/json",
      observe: 'response', withCredentials: true
    };
    api_headers.responseType = "arraybuffer"
    let url = `${this.proxyEndpoint}/getTracks/v1/track/download?guid=${guid}`;
    if (trackVersion) {
      url = url.concat(`&trackVersion=${trackVersion}`);
    }
    return this.httpClient.get(url, api_headers);
  }



  getAddressFromCoordinates(lat: any, long: any) {
    if (!this.platform) {
const mapKey = this._translationService.allSecrets.hereMapApiKey
    this.platform = new H.service.Platform({
        apikey: mapKey,
      });
    }
    
    const service = this.platform.getSearchService();
    let address: any;
    return service.reverseGeocode({
      at: lat + "," + long,
    });
  }
  
  /**
   * @param pageSize 
   * @param pageNo 
   * @param nameMatches 
   * @param isCircuits 
   * @param isEmotionTour 
   * @param isOffroad 
   * @returns list of circuits, emotion tour and offraod tours
   */
  public gobalSearch(pageSize: number, pageNo: number, nameMatches: string, isCircuits: boolean, isEmotionTour: boolean, isOffroad: boolean, includeOffroadParks: boolean): Observable<any> {
    const locationFeatureFlags = this._translationService.featureFlags.locations;
    isOffroad = isOffroad && locationFeatureFlags.enableoffroadfeature;
    isEmotionTour = isEmotionTour && locationFeatureFlags.enableEmotionTourFeature;
    isCircuits = isCircuits && locationFeatureFlags.enableCircuitFeature;
    includeOffroadParks = includeOffroadParks && locationFeatureFlags.enableOffroadPark
    const visibility = "PERMANENT,TEMPORARY";
    const url = encodeURI(
      `${this.proxyEndpoint}/callLocApi/v1/search?pageSize=${pageSize}&pageNumber=${pageNo}&nameMatches=${nameMatches}&circuits=${isCircuits}&emotionTours=${isEmotionTour}&offRoadTours=${isOffroad}&offRoadParks=${includeOffroadParks}&visibility=${visibility}`
    );
    return this.httpClient.get<any>(url, {observe: 'response', withCredentials: true});
  }

  dealerAnnotationSearch(
    pageSize: any,
    pageNo: any,
    nameMatches: any,
    query:any
  
  ) {
    const url = encodeURI(
      `${this.proxyEndpoint}/callLocApi/v1/search/annotation?size=${pageSize}&pageNumber=${pageNo}&nameMatches=${nameMatches}&query=${query}`
    );
    return this.httpClient.get<any>(url, {observe: 'response', withCredentials: true});
  }

  getEmotionTourDetails(guid: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v1/track/encoded?guid=${guid}&precision=5`;

    return this.httpClient.get(url, {observe: 'response', withCredentials: true});
  }

  /**
   * @description Called when we save AMG annotation details from Add Details screen
   * @param annotationId 
   * @returns Observable
   */
  public getAnnotationDetails(annotationId: string): Observable<any> {
    let api_headers:any = {
        "Content-Type": "application/json",  observe: 'response', withCredentials: true,
    };
    const url = `${this.proxyEndpoint}/callLocApi/v1/poi/annotation/details?annotationId=${annotationId}`;
    return this.httpClient.get(url, api_headers)
    // .pipe(map((res) => {
    //   return res as unknown as AmgAnnoDtlsResponse
    // }));
  }

  deleteAnnotation(annotationId: any): Observable<any> {
    const url = `${this.proxyEndpoint}/callLocApi/v1/poi/annotation?annotationId=${annotationId}`;
    return this.httpClient.delete<any>(url, { observe: 'response', withCredentials: true});
  }

  getEmotionTourWithAnnotations(guid: any, caller: string): Observable<any> {
    let api_header: any = {
      // headers: {
      //   caller: caller,
      //   "Content-Type": "application/json",
      // }, 
      observe: 'response', withCredentials: true, "content-type": "application/json"
    };
    let url = `${this.proxyEndpoint}/callLocApi/v1/annotation/geojson?guid=${guid}`;

    return this.httpClient.get(url, api_header);
  }

  getEmotionTourWith3dCallerAnnotations(guid: any, caller: string): Observable<any> {
    let api_header: any = {
      observe: 'response', withCredentials: true, "content-type": "application/json"
    };
    let url = `${this.proxyEndpoint}/call3dLocApi/v1/annotation/geojson?guid=${guid}`;

    return this.httpClient.get(url, api_header);
  }
  getGeoSearchAddress(centerCoordinates:any,limit:number,lang:string,term:string): Observable<any> {
    const mapKey = this._translationService.allSecrets.hereMapApiKey
    const url = `https://autosuggest.search.hereapi.com/v1/autosuggest?at=${centerCoordinates}&limit=${limit}&lang=${lang}&q=${term}&apiKey=${mapKey}`;
    return this.httpClient.get(url);
  } 

  public createGeofenceValidation(encodedPolyline: any, geofenceType: string): Observable<any> {
    const url = `${this.proxyEndpoint}/checkgeojson/v1/circuit/geofence/validate?circuitType=${geofenceType}`;
    return this.httpClient.post(url, encodedPolyline, { observe: 'response', withCredentials: true });
  }

  fetchYourTracks(user:any, centerCoordinates:any) {
    const url = `${this.baseUrl}/callLocApi/v2/track/sharedtracks?point=${centerCoordinates}&radius=8000&visibility=CLOSED,PERMANENT,TEMPORARY`;
    let api_header:any = {
        "Content-Type": "application/json", observe: 'response', withCredentials: true,
    };
    return this.httpClient.get(url, api_header);
  }

  public sendTourToCar(tourGuid: string, vin: string): Observable<any> {
    const url = `${this.proxyEndpoint}/checkgeojson/v1/fleet/add?guid=${tourGuid}`;
    let api_header:any = {
        "vin": vin,  observe: 'response', withCredentials: true,
    };
    return this.httpClient.post(url, { "vin": vin}, api_header);
  }

  /**
   * @description Called to upload tour guide json data
   * @param data 
   * @param guid 
   * @param locale 
   * @returns Observable
   */
  public uploadTourSpeechJson(data: any, guid: string, locale: string): Observable<any> {
    const url = `${this.baseUrl}/v1/tourguide/upload`;
    let formData = new FormData();
    formData.append("file", data);
    formData.append('guid', guid);
    formData.append('locale', locale);
    return this.httpClient.post(url, formData);
  }

  public getPreSignedUrls(fileNames: string[], asset_type: string, guid?: string): Observable<any> {
    let request: {fileName: string, type: string}[] = []
    fileNames.forEach(fileName => {
      const reqItem: any = {
        fileName,
        type: asset_type
      };
      if (guid) {
        reqItem.assetId = guid;
      }
      request = [...request, reqItem];
    })
    return this.httpClient.post(`${this.proxyEndpoint}/callLocApi/v1/preSignedUrl`, request, { observe: 'response', withCredentials: true});
  }

  public uploadMediaFilesToBlobStorage(url: string, file: File): Observable<any> {
    const headers = {
      'x-ms-blob-type': 'BlockBlob'
    }
    return this.httpClient.put(url, file, { headers });
  }
}
